export { default } from './SnackbarContent';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/SnackbarContent/index.js
// module id = 337
// module chunks = 0